export const gridTableHeadData = [
    {
        text1: 'Extra small',
        text2: '<576px'
    },
    {
        text1: 'Small',
        text2: '≥576px'
    },
    {
        text1: 'Medium',
        text2: '≥768px'
    },
    {
        text1: 'Large',
        text2: '≥992px'
    },
    {
        text1: 'Extra large',
        text2: '≥1200px'
    },
    {
        class: 'digits',
        text1: 'Extra extra large',
        text2: '≥1400px'
    },
]

export const gridColumnData = [
    {
        class: 'col-md-1',
        text: 'col-md-1'
    },
    {
        class: 'col-md-2',
        text: 'col-md-2'
    },
    {
        class: 'col-md-2',
        text: 'col-md-2'
    },
    {
        class: 'col-md-3',
        text: 'col-md-3'
    },
    {
        class: 'col-md-4',
        text: 'col-md-4'
    },
    {
        class: 'col-md-5',
        text: 'col-md-5'
    },
    {
        class: 'col-md-7',
        text: 'col-md-7'
    },
    {
        class: 'col-md-6',
        text: 'col-md-6'
    },
    {
        class: 'col-md-6',
        text: 'col-md-6'
    },
    {
        class: 'col-md-8',
        text: 'col-md-8'
    },
    {
        class: 'col-md-4',
        text: 'col-md-4'
    },
    {
        class: 'col-md-9',
        text: 'col-md-9'
    },
    {
        class: 'col-md-3',
        text: 'col-md-3'
    },
    {
        class: 'col-md-10',
        text: 'col-md-10'
    },
    {
        class: 'col-md-2',
        text: 'col-md-2'
    },
    {
        class: 'col-md-12',
        text: 'col-md-12'
    }
]

export const gridBorderBodyData = [
    {
        class: 'col-3 order-3',
        text: 'First Item (order-3)'
    },
    {
        class: 'col-5 order-first',
        text: 'Second Item (order-first)'
    },
    {
        class: 'col-4 order-last',
        text: 'Third Item (order-last)'
    },
    {
        class: 'col-3 order-2',
        text: 'Fourth Item (order-2)'
    },
    {
        class: 'col-sm-2 col-4 order-5',
        text: 'fifth Item (order-5)'
    },
    {
        class: 'col-sm-6 col-4 order-4',
        text: 'sixth Item (order-4)'
    }
]

export const offsetBodyData = [
    {
        class: 'col-sm-5 col-4 offset-sm-3 offset-2',
        text: 'col-5 offset-3'
    },
    {
        class: 'col-sm-2 col-4 offset-sm-2 offset-1',
        text: 'col-2 offset-2'
    },
    {
        class: 'col-sm-4 col-5 offset-2',
        text: 'col-4 offset-2'
    },
    {
        class: 'col-sm-3 col-4 offset-sm-2 offset-1',
        text: 'col-3 offset-2'
    }
]